/**
 * @file コンポーネント：利用規約日本語 DOM管理
 */

// ライブラリ読み込み
import React from "react";

// スタイル読み込み
import { StyledTerms } from "./style";

// Presenterを返す
export const Presenter = (props) => {
    // ReactDOM
    return (
        <StyledTerms data-on-color={props.onColor}>
            <h3>
                OPExPARK 利用規約
            </h3>
            <section>
                <h4>
                    適用
                </h4>
                <ol>
                    <li>
                        この利用規約（以下「本規約」といいます。）は、株式会社OPExPARK（以下「当社」といいます。）が運営する「opeXpark」（以下「本サービス」といいます。）を利用するユーザー（以下「ユーザー」といいます。）に適用されます。ユーザーは、本規約に同意の上、本サービスを利用します。
                    </li>
                    <li>
                        本規約は、本サービスの利用条件を定めています。本サービスにユーザー登録したユーザーは全て本規約に従い、年齢や利用環境等の条件に応じて、本規約の定める条件に従って本サービスを利用します。
                    </li>
                    <li>
                        ユーザーが本規約に同意することにより、当社との間に本契約（第2条で定義します。）が成立します。
                    </li>
                </ol>
            </section>
            <section>
                <h4>
                    定義
                </h4>
                <p>
                    本規約において使用する以下の用語は、以下の各号に定める意味を有します。
                </p>
                <ol data-hierarchy="second">
                    <li>
                        「本契約」：本規約を契約条件として当社及びユーザーとの間で締結される、本サービスの利用契約を指します。
                    </li>
                    <li>
                        「本サービス」：当社が提供する「opeXpark」という名称のサービス（理由の如何を問わずサービスの名称または内容が変更された場合は、当該変更後のサービスを含みます。）を指します。
                    </li>
                    <li>
                        「有料サービス」：本サービスのうち、有料にて提供されるサービスを指します。
                    </li>
                    <li>
                        「ユーザー」：本サービスのユーザー登録をしている全ての方を指します。
                    </li>
                    <li>
                        「ユーザー情報」：本サービスに登録したユーザーのID及びパスワードを指します。
                    </li>
                    <li>
                        「通信機器」： スマートフォン、タブレット端末及びコンピューター機器を指します。
                    </li>
                </ol>
            </section>
            <section>
                <h4>
                    ユーザー登録
                </h4>
                <ol>
                    <li>
                        本サービスのユーザーになろうとする方は、本規約の内容に同意の上、当社が定める手続きによりユーザー登録を行います。ただし、登録が可能なユーザーは国が定める医師免許を保有している方のみです。
                    </li>
                    <li>
                        ユーザーは、前項に基づき登録した情報に変更が発生した場合、直ちに、登録情報の変更手続を行う義務を負います。
                    </li>
                    <li>
                        当社は、当社の裁量により、ユーザー登録を拒否する場合があります。またその理由について一切開示義務を負いません。
                    </li>
                    <li>
                        ユーザーは、本サービス上のアカウントを第三者に対して利用、貸与、譲渡、売買又は質入等をすることはできません。
                    </li>
                </ol>
            </section>
            <section>
                <h4>
                    本サービスの内容
                </h4>
                <p>
                    本サービスは、ユーザーに対して手術手技およびそれに伴う関連情報を提供するサービスです。
                </p>
            </section>
            <section>
                <h4>
                    利用料金
                </h4>
                <ol>
                    <li>
                        ユーザーは、当社に対して、有料サービスの利用の対価として、当社がコンテンツごとに別途定める利用料金を、当社所定の決済手段（クレジットカード等）により支払うものとします。
                    </li>
                    <li>
                        有料サービスを利用するユーザーは、コンテンツの性質上、ご注文された後のコンテンツの変更およびご注文のキャンセルはできないものとし、当社は、いかなる場合にも受領した利用料金の返金には応じません。
                    </li>
                    <li>
                        本サービスを利用するために必要となる通信費および通信機器等は、利用ユーザーの負担と責任により準備するものとします。但し、利用ユーザーの使用する通信機器等において、本ウェブサイトおよび本サービスが正常に動作することを保証するものではありません。
                    </li>
                </ol>
            </section>
            <section>
                <h4>
                    ユーザー情報及び通信機器に関する管理
                </h4>
                <ol>
                    <li>
                        ユーザーは、本サービスの提供を受けるために必要な機器、通信手段及び交通手段等の環境を全て自らの費用と責任で備えます。また、本サービスの利用にあたり必要となる通信費用は、全てユーザーの負担とします。
                    </li>
                    <li>
                        ユーザーは、ユーザー情報及び通信機器の管理責任を負います。ユーザー情報及び通信機器の管理不十分、使用上の過誤、第三者の使用等による損害の責任はユーザーが負い、当社は当社に故意又は過失のない限り一切の責任を負いません。
                    </li>
                    <li>
                        ユーザーは、ユーザー情報又は通信機器を第三者に使用されるおそれのある場合は、直ちに当社にその旨を連絡するとともに、当社の指示がある場合はこれに従います。
                    </li>
                </ol>
            </section>
            <section>
                <h4>
                    本サービスの提供条件
                </h4>
                <p>
                    当社は、メンテナンス等のために、ユーザーに通知することなく、本サービスを停止又は変更することがあります。
                </p>
            </section>
            <section>
                <h4>
                    知的財産権等
                </h4>
                <ol>
                    <li>
                        ユーザーが本サービス上において投稿等を行った場合、著作物性の有無を問わず、掲載内容の一部又は全部に関し、発生しうる全ての著作権（著作権法第27条及び第28条に定める権利を含みます。）について、目的を問わず、無償かつ無制限に利用できる権利を当社に対して許諾することについて同意します。
                    </li>
                    <li>
                        ユーザーは、方法又は形態の如何を問わず、本サービスにおいて提供される全ての情報及びコンテンツ（以下総称して「当社コンテンツ」といいます。）を著作権法に定める、私的使用の範囲を超えて複製、転載、公衆送信、改変その他の利用をすることはできません。
                    </li>
                    <li>
                        当社コンテンツに関する著作権、特許権、実用新案権、商標権、意匠権その他一切の知的財産権及びこれらの権利の登録を受ける権利（以下総称して「知的財産権」といいます。）は、当社又はそれぞれの権利者である第三者に帰属し、ユーザーには帰属しません。また、ユーザーは、知的財産権の存否にかかわらず、当社コンテンツについて、複製、配布、転載、転送、公衆送信、改変、翻案その他の二次利用等を行ってはなりません。
                    </li>
                    <li>
                        ユーザーが本条の規定に違反して問題が発生した場合、ユーザーは、自己の費用と責任において当該問題を解決するとともに、当社に何らの不利益、負担又は損害を与えないよう適切な措置を講じなければなりません。
                    </li>
                    <li>
                        ユーザーは、著作物となりうる掲載内容の一部について、当社並びに当社より正当に権利を取得した第三者及び当該第三者から権利を承継した者に対し、著作者人格権（公表権、氏名表示権及び同一性保持権を含みます。）を行使しません。
                    </li>
                </ol>
            </section>
            <section>
                <h4>
                    禁止事項
                </h4>
                <ol>
                    <li>
                        当社は、ユーザーによる本サービスの利用に際して、以下の各号に定める行為を禁止します。
                        <ol data-hierarchy="second">
                            <li>
                                本規約に違反する行為
                            </li>
                            <li>
                                当社、当社がライセンスを受けているライセンサーその他第三者の知的財産権、特許権、実用新案権、意匠権、商標権、著作権、肖像権等の財産的又は人格的な権利を侵害する行為又はこれらを侵害する恐れのある行為
                            </li>
                            <li>
                                当社又は第三者に不利益若しくは損害を与える行為又はその恐れのある行為
                            </li>
                            <li>
                                不当に他人の名誉や権利、信用を傷つける行為又はその恐れのある行為
                            </li>
                            <li>
                                法令又は条例等に違反する行為
                            </li>
                            <li>
                                公序良俗に反する行為若しくはその恐れのある行為又は公序良俗に反する恐れのある情報を他のユーザー又は第三者に提供する行為
                            </li>
                            <li>
                                犯罪行為、犯罪行為に結びつく行為若しくはこれを助長する行為又はその恐れのある行為
                            </li>
                            <li>
                                事実に反する情報又は事実に反する恐れのある情報を提供する行為
                            </li>
                            <li>
                                当社のシステムへの不正アクセス、それに伴うプログラムコードの改ざん、位置情報の改ざん、故意に虚偽、通信機器の仕様その他アプリケーションを利用してのチート行為、コンピューターウィルスの頒布その他本サービスの正常な運営を妨げる行為又はその恐れのある行為
                            </li>
                            <li>
                                マクロ及び操作を自動化する機能やツール等を使用する行為
                            </li>
                            <li>
                                本サービスの信用を損なう行為又はその恐れのある行為
                            </li>
                            <li>
                                青少年の心身及びその健全な育成に悪影響を及ぼす恐れのある行為
                            </li>
                            <li>
                                他のユーザーのアカウントの使用その他の方法により、第三者になりすまして本サービスを利用する行為
                            </li>
                            <li>
                                詐欺、預貯金口座及び携帯電話の違法な売買等の犯罪に結びつく又は結びつく恐れのある行為
                            </li>
                            <li>
                                犯罪収益に関する行為、テロ資金供与に関する行為又はその疑いがある行為
                            </li>
                            <li>
                                画面キャプチャ等の表示画面を記録する行為
                            </li>
                            <li>
                                その他当社が不適当と判断する行為
                            </li>
                        </ol>
                    </li>
                    <li>
                        当社は、ユーザーの行為が、第１項各号のいずれかに該当すると判断した場合、事前に通知することなく、以下の各号のいずれか又は全ての措置を講じることができます。
                        <ol data-hierarchy="second">
                            <li>
                                本サービスの利用制限
                            </li>
                            <li>
                                本契約の解除による退会処分
                            </li>
                            <li>
                                当該ユーザーにより投稿されたコンテンツの削除および本サービス上での公開範囲の変更
                            </li>
                            <li>
                                その他当社が必要と合理的に判断する行為
                            </li>
                        </ol>
                    </li>
                </ol>
            </section>
            <section>
                <h4>
                    解除
                </h4>
                <ol>
                    <li>
                        当社は、ユーザーが以下の各号のいずれかに該当した場合、何らの通知等を要することなく、本契約を解除し、退会させることができます。
                        <ol data-hierarchy="second">
                            <li>
                                登録情報に虚偽の情報が含まれている場合
                            </li>
                            <li>
                                医師免許保有者ではない場合
                            </li>
                            <li>
                                過去に当社から退会処分を受けていた場合
                            </li>
                            <li>
                                ユーザーの相続人等からユーザーが死亡した旨の連絡があった場合又は当社がユーザーの死亡の事実を確認できた場合
                            </li>
                            <li>
                                未成年が法定代理人の同意なく、本サービスを利用した場合
                            </li>
                            <li>
                                成年被後見人、被保佐人又は被補助人が、成年後見人、保佐人又は補助人等の同意なく、本サービスを利用した場合
                            </li>
                            <li>
                                当社からの要請に対し誠実に対応しない場合
                            </li>
                            <li>
                                その他当社が不適当と判断した場合
                            </li>
                        </ol>
                    </li>
                    <li>
                        前項各号に掲げる場合のほか、当社は、ユーザーに対して30日前までに事前に通知することにより、本契約を解除し、退会させることができます。また、ユーザーが退会を希望する場合、当社が定める退会手続により、当月末日をもって本契約を解除し、退会することができます。
                    </li>
                    <li>
                        第1項及び第2項の措置により退会したユーザーは、退会時に期限の利益を喪失し、直ちに、当社に対し負担する全ての債務を履行します。
                    </li>
                </ol>
            </section>
            <section>
                <h4>
                    非保証・免責
                </h4>
                <ol>
                    <li>
                        本サービスの内容について、その完全性、正確性及び有効性等について、当社は一切の保証をしません。また、当社は、本サービスに中断、中止その他の障害が生じないことを保証しません。
                    </li>
                    <li>
                        ユーザーが本サービスを利用するにあたり、本サービスから本サービスに関わる第三者が運営する他のサービス（以下「外部サービス」といいます。）に遷移する場合があります。その場合、ユーザーは、自らの責任と負担で外部サービスの利用規約等に同意の上、本サービス及び外部サービスを利用します。なお、外部サービスの内容について、その完全性、正確性及び有効性等について、当社は一切の保証をしません。
                    </li>
                    <li>
                        ユーザーが登録情報の変更を行わなかったことにより損害を被った場合でも、当社は一切の責任を負いません。
                    </li>
                    <li>
                        ユーザーは、法令の範囲内で本サービスをご利用ください。本サービスの利用に関連してユーザーが日本又は外国の法令に触れた場合でも、当社は一切の責任を負いません。
                    </li>
                    <li>
                        予期しない不正アクセス等の行為によってユーザー情報を盗取された場合でも、それによって生じるユーザーの損害等に対して、当社は一切の責任を負いません。
                    </li>
                    <li>
                        当社は、天災、地変、火災、ストライキ、通商停止、戦争、内乱、感染症の流行その他の不可抗力により本契約の全部又は一部に不履行が発生した場合、一切の責任を負いません。
                    </li>
                    <li>
                        本サービスの利用に関し、ユーザーが他のユーザーとの間でトラブル（本サービス内外を問いません。）になった場合でも、当社は一切の責任を負わず、ユーザー間のトラブルは、当該ユーザーが自らの費用と負担において解決します。
                    </li>
                </ol>
            </section>
            <section>
                <h4>
                    損害賠償責任
                </h4>
                <ol>
                    <li>
                        ユーザーは、本規約の違反又は本サービスの利用に関連して当社に損害を与えた場合、当社に発生した損害（逸失利益及び弁護士費用を含みます。）を賠償します。
                    </li>
                    <li>
                        次項を除く本規約の他の定めにかかわらず、当社は、当社の帰責事由によりユーザーに損害を与えた場合、次の各号に定める範囲でのみその損害を賠償する責任を負います。
                        <ol data-hierarchy="second">
                            <li>
                                当社の故意又は重過失による場合：当該損害の全額
                            </li>
                            <li>
                                当社の軽過失による場合：現実かつ直接に発生した通常の損害（特別損害、逸失利益、間接損害及び弁護士費用を除く。）の範囲内とする
                            </li>
                        </ol>
                    </li>
                    <li>
                        前項にかかわらず、ユーザーが法人である場合又は個人が事業として若しくは事業のために本サービスを利用する場合には、当社に故意又は重過失のない限り、本サービスに関連して当該ユーザーが被った損害につき当社は一切の責任を負いません。なお、当社が損害を賠償する場合は、損害発生日から直近1年間の利用料金の累積総額を上限とします。
                    </li>
                </ol>
            </section>
            <section>
                <h4>
                    本サービスの内容変更・廃止
                </h4>
                <ol>
                    <li>
                        当社は、当社の裁量により本サービスの一部または全部の内容を変更または廃止することができます。
                    </li>
                    <li>
                        前項の場合、当社に故意又は重過失がある場合を除き、当社は一切の責任を負いません。
                    </li>
                </ol>
            </section>
            <section>
                <h4>
                    秘密保持
                </h4>
                <ol>
                    <li>
                        ユーザー及び当社は、本サービスの提供に関して知り得た相手方の秘密情報（本サービスに関するノウハウ、当社のシステムに関する情報、技術上又は営業上の一切の秘密情報を含みます。）を、厳重かつ適正に管理するものとし、相手方の事前の書面による同意なく第三者（当社の関連会社及び委託先を含みます。）に開示、提供及び漏洩しないものとします。
                    </li>
                    <li>
                        次の各号の情報は、秘密情報に該当しないものとします。
                        <ol data-hierarchy="second">
                            <li>
                                開示を受けた時、既に所有していた情報
                            </li>
                            <li>
                                開示を受けた時、既に公知であった情報又はその後自己の責に帰さない事由により公知となった情報
                            </li>
                            <li>
                                開示を受けた後に、第三者から合法的に取得した情報
                            </li>
                            <li>
                                開示された秘密情報によらず独自に開発し又は創作した情報
                            </li>
                            <li>
                                法令の定め又は裁判所の命令に基づき開示を要請された情報
                            </li>
                        </ol>
                    </li>
                    <li>
                        ユーザー及び当社は、相手方の指示があった場合又は本契約が終了した場合は、相手方の指示に従い速やかに秘密情報を、原状に回復した上で返却又は廃棄し、以後使用しないものとします。
                    </li>
                    <li>
                        当社は、ユーザーの同意を得て当社の関連会社又は委託先にユーザーの秘密情報を開示した場合、当該関連会社及び委託先の当該秘密情報の取扱いについて一切の責任を負いません。
                    </li>
                    <li>
                        当社は、本サービスを提供する目的のために、ユーザーの秘密情報を利用することができます。
                    </li>
                </ol>
            </section>
            <section>
                <h4>
                    反社会的勢力の排除
                </h4>
                <ol>
                    <li>
                        ユーザー及び当社は、現在、暴力団、暴力団員、暴力団員でなくなった時から5年を経過しない者、暴力団準構成員、暴力団関係企業、総会屋等、社会運動等標ぼうゴロ又は特殊知能暴力集団等、その他これらに準ずる者（以下総称して「暴力団員等」といいます。）に該当しないこと、及び次の各号のいずれにも該当しないことを表明し、かつ将来にわたっても該当しないことを保証します。
                        <ol data-hierarchy="second">
                            <li>
                                暴力団員等が経営を支配していると認められる関係を有すること
                            </li>
                            <li>
                                暴力団員等が経営に実質的に関与していると認められる関係を有すること
                            </li>
                            <li>
                                自己、自社若しくは第三者の不正の利益を図る目的又は第三者に損害を加える目的をもってする等、不当に暴力団員等を利用していると認められる関係を有すること
                            </li>
                            <li>
                                暴力団員等に対して資金等を提供し、又は便宜を供与する等の関与をしていると認められる関係を有すること
                            </li>
                            <li>
                                役員又は経営に実質的に関与している者が暴力団員等と社会的に非難されるべき関係を有すること
                            </li>
                        </ol>
                    </li>
                    <li>
                        ユーザー及び当社は、自ら又は第三者を利用して次の各号のいずれかに該当する行為を行わないことを確約します。
                        <ol data-hierarchy="second">
                            <li>
                                暴力的な要求行為
                            </li>
                            <li>
                                法的な責任を超えた不当な要求行為
                            </li>
                            <li>
                                取引に関して、脅迫的な言動をし、又は暴力を用いる行為
                            </li>
                            <li>
                                風説を流布し、偽計を用い又は威力を用いて相手方の信用を毀損し、又は相手方の業務を妨害する行為
                            </li>
                            <li>
                                その他前各号に準ずる行為
                            </li>
                        </ol>
                    </li>
                    <li>
                        ユーザー及び当社は、相手方が、暴力団員等若しくは第1項各号のいずれかに該当し、若しくは前項各号のいずれかに該当する行為をし、又は第1項の規定にもとづく表明・保証に関して虚偽の申告をしたことが判明した場合には、自己の責に帰すべき事由の有無を問わず、相手方に対して何らの催告をすることなく本契約を解除することができます。
                    </li>
                    <li>
                        ユーザー及び当社は、前項により本契約を解除した場合、相手方に損害が生じたとしてもこれを一切賠償する責任はないことを確認し、これを了承します。
                    </li>
                </ol>
            </section>
            <section>
                <h4>
                    お問い合わせ対応
                </h4>
                <ol>
                    <li>
                        当社は、本サービスに関するユーザーからのお問い合わせに対して回答するよう努めますが、法令又は本規約上、当社に義務又は責任が発生する場合を除き、回答の義務を負いません。
                    </li>
                    <li>
                        当社は、ユーザーからのお問い合わせに回答するか否かの基準を開示する義務を負いません。
                    </li>
                </ol>
            </section>
            <section>
                <h4>
                    地位の譲渡等
                </h4>
                <p>
                    ユーザー及び当社は、相手方の書面による事前の承諾なく、本契約上の地位又は本規約に基づく権利若しくは義務の全部又は一部につき、第三者に対し、譲渡、移転、担保設定、その他の処分をすることはできません。但し、株式譲渡若しくは事業譲渡又は合併、会社分割その他の組織再編についてはこの限りではありません。
                </p>
            </section>
            <section>
                <h4>
                    個人情報の取り扱い
                </h4>
                <p>
                    本サービスにおける個人情報の取り扱いに関しては、当社が定める「プライバシーポリシー」に基づき取り扱います。
                </p>
            </section>
            <section>
                <h4>
                    分離可能性
                </h4>
                <ol>
                    <li>
                        本規約の規定の一部が法令に基づいて無効と判断されても、本規約の他の規定は有効とします。
                    </li>
                    <li>
                        本規約の規定の一部があるユーザーとの関係で無効又は取消となった場合でも、本規約は他のユーザーとの関係では有効とします。
                    </li>
                </ol>
            </section>
            <section>
                <h4>
                    違反行為への対処方法
                </h4>
                <ol>
                    <li>
                        ユーザーは、本規約に違反する行為を発見した場合は、当社にご連絡ください。
                    </li>
                    <li>
                        ユーザーは、本規約に違反する行為への当社の対処について、異議を申し立てることはできません。
                    </li>
                </ol>
            </section>
            <section>
                <h4>
                    本契約の有効期間
                </h4>
                <p>
                    本契約の有効期間は、本契約成立時からユーザーが退会するまでの間とします。なお、第8条、第10条第3項、第11条から第13条、第15条第3項及び第4項、第17条、第19条、本条、第23条及び第24条の規定は、本契約の終了後も有効に存続するものとします。
                </p>
            </section>
            <section>
                <h4>
                    本規約の変更
                </h4>
                <ol>
                    <li>
                        当社は、当社が必要と判断したときは、民法第548条の4の規定に基づき本規約を随時変更できます。本規約が変更された後の本契約は、変更後の本規約が適用されます。
                    </li>
                    <li>
                        当社は、当社が本規約の内容を変更するときは、当該変更の事実、その効力発生日および変更内容を本規約の定めに従い会員に通知または公表します。
                    </li>
                    <li>
                        前二項の規定にかかわらず、前項の本規約の変更の周知後にユーザーが本サービスを利用した場合又は当社所定の期間内にユーザーが解約の手続をとらなかった場合、当該ユーザーは本規約の変更に同意したものとします。
                    </li>
                </ol>
            </section>
            <section>
                <h4>
                    準拠法
                </h4>
                <p>
                    本規約に関する準拠法は、全て日本国の法令が適用されます。
                </p>
            </section>
            <section>
                <h4>
                    合意管轄
                </h4>
                <p>
                    ユーザーと当社との間における一切の訴訟は、東京地方裁判所を第一審の専属的合意管轄裁判所とします。
                </p>
            </section>
            <section>
                <h4>
                    その他
                </h4>
                <ol>
                    <li>
                        ユーザーは、本規約に定めのない事項について、当社が細目等を別途定めた場合、これに従います。この場合、当該細目等は、本規約と一体をなします。
                    </li>
                    <li>
                        細目等は、当社所定の箇所に掲載した時点より効力を生じます。
                    </li>
                    <li>
                        細目等と本規約の内容に矛盾抵触がある場合、本規約が優先します。
                    </li>
                </ol>
            </section>
            <p>
                付則<br />
                2023年6月7日：制定・施行 
            </p>
        </StyledTerms>
    );
};
